export const environment = {
  production: false,
  /** If set, staff guard signs customers out and sends them here (separate customer app). */
  customerPortalUrl: '',
  /** Sage menu, list column, sync controls, and status-triggered sync. Keep false until prod keys/backend are ready. */
  sageUiEnabled: false,
  /** Set to `true` temporarily to debug failed API calls in prod builds (may log sensitive data). */
  verboseApiErrorLogging: false,
  api: {
    baseUrl: 'https://api.magaliespharma.com',
    // printServerBaseUrl:'http://10.10.0.34:3000' //'http://10.10.0.109:3000',
    // printServerBaseUrl:'http://10.10.0.15:3000' //'http://10.10.0.109:3000',
    // printServerBaseUrl:'http://10.10.0.17:3000' //'http://10.10.0.109:3000',
    printServerBaseUrl:'http://printserver:3000' //'http://10.10.0.109:3000',
  },
  s3: {
    region: 'eu-west-1',
    bucket: 'heisenberg-prescriptions-prod',
    fileName: 'prescription.pdf',
    folder: 'prescriptions'
  },
  auth: {
    identityPoolId: 'eu-west-1:1a5df1fe-4492-42f7-b731-fd0ce5564baa',
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_IccGhvZ7X',
    userPoolWebClientId: '7kuugqnlckivoplb7r8qgs668o',
    mandatorySignIn: true
  },
  printing: {
    dispensed_by: "J Lubbe"
  },
  what3words: {
    host: 'https://api.what3words.com',
    apiVersion: 'v3',
    apiKey: 'IB0IQ9PM'
  },
  waybill: {
      magaliesConfig: {
        sendAccNo: "PRYPP430",
        sendSite: "TEST01",
        sendCompany: "Magalies Pharmaceuticals",
        unit: "1",
        street: "Port 298",
        city: "Kosmos Skeerpoort",
        surburb: "Kosmos Skeerpoort",
        postalCode: "0261",
        buildingNumber: "1",
        buildingComplexName: "Unit 1",
        longitude: "-12.567890",
        latitude: "23.907777",
        w3w: "test.test.test",
        contactPerson: "MBP Compounding",
        homeTel: "1234567890",
        workTel: "0122071631",
        cell: "0987654321",
        storeCode: "JSON",
        serviceType: "ONX",
        company: "Magalies Pharmaceuticals"
      },
      baseUrl: "http://swatws.dawnwing.co.za/dwwebservices/v2/uat/api",
      userName: "username",
      password: "password",
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.